/**
 * What `GET /services/pms/products/admin/queue-stats` returns
 * (BE pms-product.service.ts `getQueueStatistics`).
 */
export interface QueueJob {
    _id: string;
    batchId?: string;
    vendorId: string;
    operation: string;
    status: string;
    error?: string;
    errorDetails?: {
        category?: string;
        userMessage?: string;
        code?: string;
    };
    attempts: number;
    createdAt: string;
    processingStartedAt?: string;
    completedAt?: string;
    jobName: string;
    pattern?: string;
    source?: 'standalone' | 'bulk';
    isBulkSeamless?: boolean;
    resultUrl?: string;
    resultProductId?: string;
}

export interface QueueBatchSummary {
    _id: string;
    vendorId: string;
    totalJobs: number;
    pending: number;
    processing: number;
    generating_seamless?: number;
    completed: number;
    failed: number;
    createdAt: string;
    lastUpdated?: string;
    source?: 'standalone' | 'bulk';
}

export interface QueueStats {
    queue: string;
    summary: {
        pending: number;
        processing: number;
        generating_seamless: number;
        completed: number;
        failed: number;
        total: number;
    };
    recentJobs: QueueJob[];
    failedJobs: Array<any>;
    /** In-flight for over an hour, oldest first — may be older than the 100 recent jobs. Absent on older APIs. */
    stuckJobs?: QueueJob[];
    batchSummaries: QueueBatchSummary[];
    throughput: {
        completedPerHour: number;
        averageProcessingTimeMs: number;
    };
    serviceBusEnabled: boolean;
}

export type QueueType = 'bulk-products' | 'seamless';
/** `stuck`: still waiting or running an hour after creation (the API lists these apart). */
export type StatusFilter = 'all' | 'active' | 'completed' | 'failed' | 'waiting' | 'stuck';
export type HoursFilter = 1 | 6 | 24 | 48 | 168 | 720;

export const HOURS_OPTIONS: HoursFilter[] = [1, 6, 24, 48, 168, 720];
export const CLEANUP_DAYS = [7, 30, 90] as const;
export type CleanupDays = (typeof CLEANUP_DAYS)[number];

/** The phrase the backend requires (and the dialog asks to be typed) before deleting every job. */
export const DELETE_ALL_PHRASE = 'DELETE_ALL_JOBS';
